
import React from 'react';
import { CycleData } from '@/utils/cycle-tracking';
import PeriodTrackingDashboard from '@/components/cycle-tracking/PeriodTrackingDashboard';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DashboardHeader } from '@/components/symptom-reporting/DashboardHeader';

interface DashboardTabProps {
  cycleData: CycleData | null;
  isLoading: boolean;
}

const DashboardTab: React.FC<DashboardTabProps> = ({ cycleData, isLoading }) => {
  return (
    <div className="space-y-6">
      <DashboardHeader 
        title="Period Dashboard" 
        description="Track and visualize your menstrual cycle to better understand your body's patterns and optimize your health."
      />
      
      <Card className="bg-white border-hormony-beige/50 shadow-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-xl font-medium text-hormony-charcoal">Period Overview</CardTitle>
        </CardHeader>
        <CardContent>
          <PeriodTrackingDashboard cycleData={cycleData} />
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardTab;
